/**
 * This file handles First America's custom hubspot fields: community_of_interest, utm_campaign,
 * utm_source, utm_medium, utm_term, and utm_content.
 */
import { getCookie } from "./utm_params.js";

/** Fill in the hubspot form from the community or masterplan name in the dataLayer
 * @param {HTMLFormElement} form
 */
function populateLandmarkHubspotForm(form) {
    /**
     * @type {string[] | null}
     * @description The utm_params cookie is a JSON string with the following keys:
     * utm_source, utm_medium, utm_campaign, utm_term, and utm_content.
     */
    const utmParams = getCookie("utm_params");
    if (utmParams) {
        const utmParamsObj = JSON.parse(utmParams[1]);
        form.elements["utm_source"].value = utmParamsObj.utm_source || "";
        form.elements["utm_medium"].value = utmParamsObj.utm_medium || "";
        form.elements["utm_campaign"].value = utmParamsObj.utm_campaign || "";
        form.elements["utm_term"].value = utmParamsObj.utm_term || "";
        form.elements["utm_content"].value = utmParamsObj.utm_content || "";
    }
}

/** Watches for a new element and resolves the promise with it when found.
 * @param {HTMLElement} parentElement
 * @param {string} elementTagName */
async function watchForNewElement(parentElement, elementTagName) {
    const foundElement = parentElement.querySelector(elementTagName);
    if (foundElement) {
        // already exists. skip the MutationObserver and just resolve.
        return Promise.resolve(foundElement);
    }

    return new Promise((resolve, reject) => {
        const myObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === "childList") {
                    for (const element of mutation.addedNodes.values()) {
                        if (element.tagName && element.tagName.toLowerCase() === elementTagName) {
                            // found you!
                            myObserver.disconnect();
                            resolve(element);
                            return;
                        }
                    }
                }
            }
        });

        myObserver.observe(parentElement, {
            childList: true,
            subtree: true,
        });
    });
}

/** This watches for the iframe and then the form inside the iframe to attach our custom
 * form loaded event. This is an alternative to using hubspot's own onFormReady so that
 * first america does not need to inject our JavaScript.
 */
async function watchForHubspotForm(formParent) {
    // 1. watch for form to be added
    /** @type {HTMLFormElement} */
    const form = await watchForNewElement(formParent, "form");

    // 2. add a submit handler to inject our data
    form.addEventListener("submit", (ev) => {
        populateLandmarkHubspotForm(form);
    });
}

// Find all form parents and begin watching for the form
document.addEventListener("DOMContentLoaded", () => {
    // Find all elements with the data attribute
    // and begin watching for the form
    // @ts-ignore
    const rootElements = document.querySelectorAll("[data-landmark-hubspot-form-injection]");
    // TODO: Add this when builder begins using utm params
    // Populate utm fields for oi forms, too
    /** @type {NodeListOf<HTMLFormElement>} */
    // const oiForms = document.querySelectorAll(".oi-form");

    // for (let form of oiForms) {
    //     populateLandmarkHubspotForm(form);
    // }

    rootElements.forEach((element) => {
        void watchForHubspotForm(element);
    });
});
